import { FC } from 'react'
import cn from 'classnames'

export enum StatusBadgeType {
  default = 'pmui-bg-gray-200 pmui-text-pop-gray-400 pmui-border-gray-200',
  alert = 'pmui-bg-aliceBlue pmui-text-brightNavyBlue pmui-border pmui-border-aliceBlue',
  error = 'pmui-bg-seaShell pmui-text-pop-red pmui-border pmui-border-seaShell',
  success = 'pmui-bg-mintGreen pmui-text-eltonGreen pmui-border pmui-border-mintGreen',
  warning = 'pmui-bg-creamOrange pmui-text-pop-orange pmui-border pmui-border-creamOrange',
  recommendation = 'pmui-bg-creamOrange pmui-text-pop-orange pmui-border pmui-border-creamOrange pmui-font-semibold',
}

interface Props {
  type: StatusBadgeType
  text: string
}

const StatusBadge: FC<Props> = ({ type, text }) => {
  if (!type || !text) {
    return null
  }

  return (
    <span
      className={cn(
        'pmui-relative pmui-inline pmui-w-max pmui-text-xs pmui-font-normal pmui-rounded pmui-border',
        'pmui-py-1 pmui-px-2',
        {
          [type]: true,
        },
      )}
    >
      {text}
    </span>
  )
}

export default StatusBadge
